import InputWrapper from "./styles";

export default function Input({ type, placeholder, multiple, required, handleChange, name }) {
  return (
    <InputWrapper
      data-testid="input-element"
      placeholder={placeholder}
      type={type}
      multiple={multiple}
      required={required}
      onBlur={(e) => handleChange(name, e.target.value)}
    />
  );
}
